import { useEffect } from 'react'
import { useSearchParams } from 'react-router'
import { isEmpty } from 'lodash-es'

import {
  EMAIL_FOLDER_DEFAULT_VALUE,
  SUBMENU_ACCOUNT_PARAM_KEY,
  SUBMENU_PARAM_KEY,
} from '../../../../../constants/route'
import { ITEM_KEYS } from '../../EmailSubMenu.constants'
import { getSubMenuEmailsDefaultValue } from '../../EmailSubMenu.utils'

export function useDefaultEmailParams({ accountList, accountsMenu }) {
  const [searchParams, setSearchParams] = useSearchParams()

  const account = searchParams.get(SUBMENU_ACCOUNT_PARAM_KEY)

  useEffect(() => {
    if (!account && !isEmpty(accountList)) {
      setSearchParams(
        params => {
          params.set(
            SUBMENU_ACCOUNT_PARAM_KEY,
            getSubMenuEmailsDefaultValue(accountList)[ITEM_KEYS.selectedKey]
          )
          params.set(
            SUBMENU_PARAM_KEY,
            params.get(SUBMENU_PARAM_KEY) || EMAIL_FOLDER_DEFAULT_VALUE
          )

          return params
        },
        { replace: true }
      )
    }
  }, [account, accountList])

  useEffect(() => {
    if (!isEmpty(accountsMenu) && isEmpty(accountList)) {
      setSearchParams({}, { replace: true })
    }
  }, [accountsMenu])
}
